import React from 'react';
import { useTheme } from 'styled-components';

import { IIconProps } from './TIcon';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function CheckIconBold({ color: colorProp }: IIconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
      <path
        d="M2.45446 5.68892C2.67589 5.91392 3.04018 5.91392 3.26161 5.68892L7.83303 1.11749C8.05803 0.896066 8.05803 0.53178 7.83303 0.310352C7.61161 0.0853516 7.24732 0.0853516 7.02589 0.310352L2.85804 4.47821L0.975893 2.59607C0.754465 2.37107 0.390179 2.37107 0.16875 2.59607C-0.05625 2.81749 -0.05625 3.18178 0.16875 3.40321L2.45446 5.68892Z"
        fill={color}
      />
    </svg>
  );
}

export default CheckIconBold;
